<!-- Невывозы -->
<template>
  <div class="failure">
    <div class="failure-title">
      <img src="@/assets/images/container_lock.svg" alt="" />
      Невывозы
    </div>
    <div class="failure-cards">
      <failure-card
        :item="item"
        v-for="(item, index) of items"
        :key="index"
      />
      <div class="preloader" v-if="loading">
        <preloaderLogo  />
      </div>
    </div>
  </div>
</template>
  
  <script>
import { global_state } from "@/store/global";
import failureCard from "./failure-card.vue";
import preloaderLogo from "@/components/icons_color/preloader_logo";

export default {
  components: { 
    failureCard,
    preloaderLogo,
   },
  data() {
    return {
      loading: false,
      items: [],
    };
  },
  mounted() {
    this.fetching();
  },
  setup() {
    const globalStore = global_state();

    return { globalStore };
  },
  methods: {
    fetching() {
      this.loading = true;

      if (this.globalStore.use_organisation?.id && this.globalStore.use_date) {
        Api.events.event_failure({
            organisation: this.globalStore.use_organisation.id,
            date: this.globalStore.use_date,
        }).then(res => {
          this.items = res.data;
        }).finally(() => {
          this.loading = false;
        })
        ;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.failure {
  padding: 0 26px;
}

.failure-title {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 22px;
  line-height: 30px;

  & img {
    margin-right: 15px;
    display: inline-block;
    width: 30px;
  }
}

.preloader {
  padding-top: 50px;
  text-align: center;
  width: 100%;
  height: 100%;
}
.failure-cards {
}
</style>